import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { WebPresets } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webencoderprofiles`,
    response: [] as WebPresets.Get.WebPreset[],
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webencoderprofiles`,
    request: {} as WebPresets.Post.WebPreset,
    method: HTTP_METHODS.POST,
  },
};

export const id = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webencoderprofiles/@id`,
    response: {} as WebPresets.Get.WebPreset,
    params: {} as { id: string },
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.PATCH]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webencoderprofiles/@id`,
    request: {} as WebPresets.Patch.WebPreset,
    params: {} as { id: string },
    method: HTTP_METHODS.PATCH,
  },
  [HTTP_METHODS.DELETE]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/webencoderprofiles/@id`,
    params: {} as { id: string },
    method: HTTP_METHODS.DELETE,
  },
};
